const getImgSrc = (data: any) => {
  switch (data) {
    case "台风红色":
      return "/static/warningIcon/taifeng_red.jpg";
    case "台风橙色":
      return "/static/warningIcon/taifeng_orange.jpg";
    case "台风黄色":
      return "/static/warningIcon/taifeng_yellow.jpg";
    case "台风蓝色":
      return "/static/warningIcon/taifeng_blue.jpg";

    case "暴雨红色":
      return "/static/warningIcon/baoyu_red.jpg";
    case "暴雨橙色":
      return "/static/warningIcon/baoyu_orange.jpg";
    case "暴雨黄色":
      return "/static/warningIcon/baoyu_yellow.jpg";
    case "暴雨蓝色":
      return "/static/warningIcon/baoyu_blue.jpg";

    case "暴雪红色":
      return "/static/warningIcon/baoxue_red.jpg";
    case "暴雪橙色":
      return "/static/warningIcon/baoxue_orange.jpg";
    case "暴雪黄色":
      return "/static/warningIcon/baoxue_yellow.jpg";
    case "暴雪蓝色":
      return "/static/warningIcon/baoxue_blue.jpg";

    case "寒潮红色":
      return "/static/warningIcon/hanchao_red.jpg";
    case "寒潮橙色":
      return "/static/warningIcon/hanchao_orange.jpg";
    case "寒潮黄色":
      return "/static/warningIcon/hanchao_yellow.jpg";
    case "寒潮蓝色":
      return "/static/warningIcon/hanchao_blue.jpg";

    case "大风红色":
      return "/static/warningIcon/dafeng_red.jpg";
    case "大风橙色":
      return "/static/warningIcon/dafeng_orange.jpg";
    case "大风黄色":
      return "/static/warningIcon/dafeng_yellow.jpg";
    case "大风蓝色":
      return "/static/warningIcon/dafeng_blue.jpg";

    case "高温红色":
      return "/static/warningIcon/gaowen_red.jpg";
    case "高温橙色":
      return "/static/warningIcon/gaowen_orange.jpg";
    case "高温黄色":
      return "/static/warningIcon/gaowen_yellow.jpg";

    case "雷电红色":
      return "/static/warningIcon/leidian_red.jpg";
    case "雷电橙色":
      return "/static/warningIcon/leidian_orange.jpg";
    case "雷电黄色":
      return "/static/warningIcon/leidian_yellow.jpg";
    case "雷电":
      return "/static/warningIcon/leidian.jpg";

    case "霜冻橙色":
      return "/static/warningIcon/shuangdong_orange.jpg";
    case "霜冻黄色":
      return "/static/warningIcon/shuangdong_yellow.jpg";
    case "霜冻蓝色":
      return "/static/warningIcon/shuangdong_blue.jpg";

    case "大雾红色":
      return "/static/warningIcon/dawu_red.jpg";
    case "大雾橙色":
      return "/static/warningIcon/dawu_orange.jpg";
    case "大雾黄色":
      return "/static/warningIcon/dawu_yellow.jpg";

    case "道路结冰红色":
      return "/static/warningIcon/daolu_red.jpg";
    case "道路结冰橙色":
      return "/static/warningIcon/daolu_orange.jpg";
    case "道路结冰黄色":
      return "/static/warningIcon/daolu_yellow.jpg";

    case "冰雹红色":
      return "/static/warningIcon/bingbao_red.jpg";
    case "冰雹橙色":
      return "/static/warningIcon/bingbao_orange.jpg";

    case "干旱红色":
      return "/static/warningIcon/ganhan_red.jpg";
    case "干旱橙色":
      return "/static/warningIcon/ganhan_orange.jpg";

    case "霾红色":
      return "/static/warningIcon/mai_red.jpg";
    case "霾橙色":
      return "/static/warningIcon/mai_orange.jpg";
    case "霾黄色":
      return "/static/warningIcon/mai_yellow.jpg";

    case "森林火险红色":
      return "/static/warningIcon/huoxian_red.jpg";
    case "森林火险橙色":
      return "/static/warningIcon/huoxian_orange.jpg";
    case "森林火险黄色":
      return "/static/warningIcon/huoxian_yellow.jpg";
    case "森林火险蓝色":
      return "/static/warningIcon/huoxian_blue.jpg";

    case "沙尘暴红色":
      return "/static/warningIcon/sha_red.jpg";
    case "沙尘暴橙色":
      return "/static/warningIcon/sha_orange.jpg";
    case "沙尘暴黄色":
      return "/static/warningIcon/sha_yellow.jpg";

    case "雷暴红色":
      return "/static/warningIcon/leibao_red.png";
    case "雷暴橙色":
      return "/static/warningIcon/leibao_orange.png";
    case "雷暴黄色":
      return "/static/warningIcon/leibao_yellow.png";

    // 补充
    case "雷雨大风红色":
      return "/static/warningIcon/leiyudafeng_red.jpeg";
    case "雷雨大风橙色":
      return "/static/warningIcon/leiyudafeng_orange.jpeg";
    case "雷雨大风黄色":
      return "/static/warningIcon/leiyudafeng_yellow.jpeg";
    case "雷雨大风蓝色":
      return "/static/warningIcon/leiyudafeng_blue.jpeg";

    case "地质灾害气象风险橙色":
      return "/static/warningIcon/dizhizaihai_orange.jpeg";
    case "地质灾害气象风险黄色":
      return "/static/warningIcon/dizhizaihai_yellow.png";

    case "低温雨雪冰冻橙色":
      return "/static/warningIcon/diwenyuxuebingdong_orange.jpg";

    case "低温雨雪冰冻黄色":
      return "/static/warningIcon/diwenyuxuebingdong_yellow.jpg";

    case "低温雨雪冰冻红色":
      return "/static/warningIcon/diwenyuxuebingdong_red.jpg";

    case "强对流红色":
      return "/static/warningIcon/qiangduiliu_red.jpg";

    case "强对流橙色":
      return "/static/warningIcon/qiangduiliu_orange.jpg";

    case "强对流黄色":
      return "/static/warningIcon/qiangduiliu_yellow.jpg";

    case "强对流蓝色":
      return "/static/warningIcon/qiangduiliu_blue.jpg";

    case "雨雾红色":
      return "/static/warningIcon/yuwu_red.jpg";

    case "雨雾橙色":
      return "/static/warningIcon/yuwu_orange.jpg";

    case "雨雾黄色":
      return "/static/warningIcon/yuwu_yellow.jpg";

    case "雨雾蓝色":
      return "/static/warningIcon/yuwu_blue.jpg";

    default:
      return "/static/warningIcon/warn_default.png";
  }
};

const getFyzn = (data: any) => {
  switch (data) {
    case "暴雨黄色": {
      return "1.政府及有关部门做好防御暴雨的准备工作;\n2.托儿所、幼儿园、中小学校、中等职业学校等应采取措施保障学生和幼儿等人员的安全;\n3.强降雨路段和积水路段加强交通管理，保障安全;\n4.切断低洼地带危险的室外电源，转移危房居民到安全场所避雨;\n5.检查城乡排水系统，采取必要排涝措施，确保塘堰、水库保持安全水位；\n6．驾驶人员注意积水道路和塌方，确保行车安全。";
      break;
    }
    case "暴雨橙色":
      return "1．政府及有关部门适时启动应急预案，做好防御暴雨的应急准备工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应停止户外教学活动，采取措施保护到校学生、幼儿和其他上班人员的安全；\n3．露天施工、井下作业等相关行业可以停工；\n4．转移地质灾害危险地带人员和危房居民到安全场所避雨；\n5．切断有危险的室外电源，暂停户外作业；\n6．做好城乡排水管网和防涝设施的运行检查和维护，防范暴雨可能引发的城市内涝和山洪、崩塌、滑坡、泥石流等灾害；\n7．在强降雨路段和积水路段加强交通管理，保障安全。驾驶人员注意路滑和塌方，快速撤离，确保行车安全。";
      break;
    case "暴雨红色":
      return "1．政府及有关部门启动应急预案，做好防御暴雨应急和抢险工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施；\n3. 除直接保障社会公众生产生活运行的单位外，露天施工、井下作业等高风险行业应停工，停止户外大型活动和群众集会，旅游景区景点暂停营业，其他单位可以采取临时停工、停业或者调整工作时间等措施；\n4. 遇有突发危及安全的情况，城市轨道交通等公共运输工具驾驶员、车站行车人员、地下空间管理人员应当及时向有关部门报告，并可以先行采取停运停工、疏散人员等紧急安全防护措施；\n5．转移危险地带人员和危房居民到安全场所暂避；\n6．在低洼易涝点设置警示标识，根据实际情况增加排水设施，做好城市内涝和山洪、滑坡、崩塌、泥石流等灾害的防御和抢险工作；\n7．加强交通管理，在隐患路段实行道路警戒和交通管制，保障安全。驾驶人员注意路滑和塌方，快速撤离，确保行车安全。";
      break;
    case "暴雪蓝色":
      return "1．政府及有关部门按照职责做好防雪灾和防冻害准备工作；\n2．交通、铁路、电力、通信等部门应当进行道路、铁路、线路巡查维护，做好道路清扫和积雪融化工作；\n3．公安等部门做好积雪路段管理，行人注意防寒防滑，驾驶人员小心驾驶，车辆应当采取防滑措施； \n4．种养殖业和农牧区要储备饲料，做好防雪灾和防冻害准备；\n5．加固棚架等易被雪压的临时搭建物。";
      break;

    case "暴雪黄色":
      return "1．政府及相关部门按照职责落实防雪灾和防冻害措施；\n2．交通、铁路、电力、通信、供水、供气等部门应当加强道路、铁路、线路、管线设备巡查维护和故障抢修工作，做好道路清扫和积雪融化工作；\n3．公安等部门加强积雪路段管理，行人注意防寒防滑，驾驶人员小心驾驶，车辆应当采取防滑措施； \n4．种养殖业和农牧区要备足饲料，做好防雪灾和防冻害准备；\n5．加固棚架等易被雪压的临时搭建物。";
      break;

    case "暴雪橙色":
      return "1．政府及相关部门按照职责做好防雪灾和防冻害的应急工作；\n2．交通、铁路、电力、通信等部门应当加强道路、铁路、线路巡查维护，做好道路清扫、积雪融化和设置警示标识工作；\n3．种养殖业和农牧区做好各类农业设施和养殖设施的除雪及管理工作；\n4．公安部门做好积雪路段交通疏导工作；\n5．减少不必要的户外活动，托儿所、幼儿园、中小学校、中等职业学校等停止户外教学活动； \n6．加固棚架等易被雪压的临时搭建物，将户外牲畜赶入棚圈喂养。";
      break;
    case "暴雪红色":
      return "1．政府及相关部门按照职责做好防雪灾和防冻害的应急和抢险工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施；\n3. 除直接保障社会公众生产生活运行的单位外，其他单位可以采取临时停工、停业或者调整工作时间等措施；\n4. 遇有突发危及安全的情况，城市轨道交通等公共运输工具驾驶员、车站行车人员、地下空间管理人员应当及时向有关部门报告，并可以先行采取停运停工、疏散人员等紧急安全防护措施；\n5．必要时飞机暂停起降，火车暂停运行，对陡坡、桥梁、高速公路等进行交通管制；\n6．做好受灾及生活困难等人群的救灾救济工作。";
      break;

    case "寒潮蓝色":
      return "1．政府及有关部门按照职责做好防寒潮准备工作；\n2．注意添衣保暖，做好防风准备工作；\n3．对农作物、水产品采取一定的防护措施。";
      break;
    case "寒潮黄色":
      return "1．政府及有关部门按照职责做好防寒潮工作；\n2．注意添衣保暖，照顾好老、弱、病人，做好防风工作；\n3．对牲畜、家禽和有关水产品、农作物等采取防寒措施。";
      break;
    case "寒潮橙色":
      return "1．政府及有关部门按照职责做好防寒潮应急工作；\n2．注意防寒保暖，照顾好老、弱、病人，做好防风工作；\n3．农业、水产业、畜牧业等要采取防霜冻、冰冻等防寒措施，尽量减少损失。";
      break;
    case "寒潮红色":
      return "1．政府及相关部门按照职责做好防寒潮的应急和抢险工作；\n2．注意防寒保暖，加强防风工作；\n3．农业、水产业、畜牧业等要积极采取防霜冻、冰冻等防寒措施，尽量减少损失。";
      break;

    case "大风蓝色":
      return "1．政府及相关部门按照职责做好防大风准备工作；\n2．关好门窗，加固围板、棚架、广告牌等易被风吹动的搭建物，妥善安置易受大风影响的室外物品，遮盖建筑物资；\n3．相关水域作业和过往船舶采取积极的应对措施； \n4．行人尽量少骑自行车，刮风时不要在广告牌、临时搭建物等下面逗留；\n5．有关部门和单位注意森林、草原等防火。";
      break;
    case "大风黄色":
      return "1．政府及相关部门按照职责做好防大风工作；\n2．作业单位停止塔吊、脚手架、玻璃幕墙清洗等室外高空作业；\n3．露天的大型娱乐、游乐、体育等设施停止使用；\n4．危险地带人员和危房居民尽量转到避风场所避风；\n5．相关水域水上作业和过往船舶采取回港避风或者绕道航行等应对措施；\n6．切断户外危险电源，妥善安置易受大风影响的室外物品，遮盖建筑物资；    \n7．机场、高速公路等单位应当采取保障交通安全的措施，有关部门和单位注意森林、草原等防火。";
      break;
    case "大风橙色":
      return "1．政府及相关部门按照职责做好防大风应急工作；\n2．作业单位停止塔吊、脚手架、玻璃幕墙清洗等室外高空作业；\n3．露天的大型娱乐、游乐、体育等设施停止使用；\n4．危险地带人员和危房居民尽量转到避风场所避风；\n5．相关水域水上作业和过往船舶采取回港避风或者绕道航行等应对措施；\n6．切断户外危险电源，妥善安置易受大风影响的室外物品，遮盖建筑物资；    \n7．机场、铁路、高速公路、水上交通等单位应当采取保障交通安全的措施，有关部门和单位注意森林、草原等防火。";
      break;
    case "大风红色":
      return "1．政府及相关部门按照职责做好防大风应急和抢险工作；\n2．托儿所、幼儿园、中小学校、中等职业学校可以停课。露天施工行业停工，停止户外大型活动和群众集会，旅游景区景点暂停营业，人员减少外出； \n3．相关水域作业和过往船舶应当采取防风措施，危险区域视情况采取水上临时交通管制措施；\n4．切断危险电源，妥善安置易受大风影响的室外物品，遮盖建筑物资；    \n5．机场、铁路、高速公路、水上交通等单位应当采取保障交通安全的措施，有关部门和单位注意森林、草原等防火。";
      break;

    case "高温黄色":
      return "1．有关部门和单位按照职责做好防暑降温准备工作；\n2．午后尽量减少户外活动；\n3．对老、弱、病、幼人群提供防暑降温指导；\n4．高温条件下作业和白天需要长时间进行户外露天作业的人员应当采取必要的防护措施。";
      break;
    case "高温橙色":
      return "1．有关部门和单位按照职责落实防暑降温保障措施；\n2．尽量避免在高温时段进行户外活动，高温条件下作业的人员应当缩短连续工作时间；\n3．对老、弱、病、幼人群提供防暑降温指导，并采取必要的防护措施；\n4．有关部门和单位应当注意防范因用电量过高，以及电线、变压器等电力负载过大而引发的火灾，烟花爆竹生产企业按照规定停产。";
      break;
    case "高温红色":
      return "1．有关部门和单位按照职责采取防暑降温应急措施；\n2．停止户外露天作业（除特殊行业外），暂停或者取消户外大型活动和群众集会；\n3．对老、弱、病、幼人群采取保护措施；\n4．有关部门和单位要特别注意防火，烟花爆竹生产企业按照规定停产。";
      break;
    case "雷电":
      return "1．政府及相关部门按照职责做好防雷应急抢险工作；\n2．人员应当尽量躲入有防雷设施的建筑物或者汽车内，并关好门窗；\n3．切勿接触天线、水管、铁丝网、金属门窗、建筑物外墙，远离电线等带电设备和其他类似金属装置；\n4．尽量不要使用无防雷装置或者防雷装置不完备的电视、电话等电器；\n5．烟花爆竹生产企业按照规定停产。";
      break;

    case "雷电黄色":
      return "1．政府及相关部门按照职责做好防雷应急抢险工作；\n2．人员应当尽量躲入有防雷设施的建筑物或者汽车内，并关好门窗；\n3．切勿接触天线、水管、铁丝网、金属门窗、建筑物外墙，远离电线等带电设备和其他类似金属装置；\n4．尽量不要使用无防雷装置或者防雷装置不完备的电视、电话等电器；\n5．烟花爆竹生产企业按照规定停产。";
      break;
    case "雷电橙色":
      return "1．政府及相关部门按照职责做好防雷应急抢险工作；\n2．人员应当尽量躲入有防雷设施的建筑物或者汽车内，并关好门窗；\n3．切勿接触天线、水管、铁丝网、金属门窗、建筑物外墙，远离电线等带电设备和其他类似金属装置；\n4．尽量不要使用无防雷装置或者防雷装置不完备的电视、电话等电器；\n5．烟花爆竹生产企业按照规定停产。";
      break;
    case "雷电红色":
      return "1．政府及相关部门按照职责做好防雷应急抢险工作；\n2．人员应当尽量躲入有防雷设施的建筑物或者汽车内，并关好门窗；\n3．切勿接触天线、水管、铁丝网、金属门窗、建筑物外墙，远离电线等带电设备和其他类似金属装置；\n4．尽量不要使用无防雷装置或者防雷装置不完备的电视、电话等电器；\n5．烟花爆竹生产企业按照规定停产。";
      break;

    case "雷雨大风蓝色":
      return "1．政府及相关部门按照职责做好防大风、防雷电准备工作；\n2．关好门窗，加固围板、棚架、广告牌等易被风吹动的搭建物，妥善安置易受雷雨大风影响的室外物品，遮盖建筑物资；\n3．相关水域作业和过往船舶采取积极的应对措施； \n4．行人注意尽量减少户外活动；\n5．有关部门和单位注意森林、草原等防火。";
      break;
    case "雷雨大风黄色":
      return "1．政府及相关部门按照职责做好防大风、防雷电工作；\n2．作业单位停止塔吊、脚手架、玻璃幕墙清洗等室外高空作业；\n3．露天的大型娱乐、游乐、体育等设施停止使用；\n4．危险地带人员和危房居民尽量转到安全场所躲避雷雨大风；\n5．相关水域作业和过往船舶采取回港避风或者绕道航行等应对措施；\n6．切断户外危险电源，妥善安置易受雷雨大风影响的室外物品，遮盖建筑物资；    \n7．机场、高速公路等单位应当采取保障交通安全的措施，有关部门和单位注意森林、草原等防火。";
      break;
    case "雷雨大风橙色":
      return "1．政府及相关部门按照职责做好防大风、防雷电应急工作；\n2．作业单位停止塔吊、脚手架、玻璃幕墙清洗等室外高空作业；\n3．露天的大型娱乐、游乐、体育等设施停止使用；\n4．危险地带人员和危房居民尽量转到安全场所躲避雷雨大风；\n5．相关水域作业和过往船舶采取回港避风或者绕道航行等应对措施；\n6．切断户外危险电源，妥善安置易受雷雨大风影响的室外物品，遮盖建筑物资；    \n7．机场、铁路、高速公路、水上交通等单位应当采取保障交通安全的措施，有关部门和单位注意森林、草原等防火。";
      break;
    case "雷雨大风红色":
      return "1．政府及相关部门按照职责做好防大风、防雷电应急和抢险工作；\n2．托儿所、幼儿园、中小学校、中等职业学校可以停课。露天施工行业停工，停止户外大型活动和群众集会，旅游景区景点暂停营业，人员减少外出； \n3．相关水域作业和过往船舶应当采取防风防雷措施，危险区域视情况采取水上临时交通管制措施；\n4．切断危险电源，妥善安置易受雷雨大风影响的室外物品，遮盖建筑物资；    \n5．机场、铁路、高速公路、水上交通等单位应当采取保障交通安全的措施，有关部门和单位注意森林、草原等防火。";
      break;

    case "冰雹橙色":
      return "1．政府及相关部门按照职责做好防冰雹的应急工作；\n2．户外行人立即到安全的地方暂避；\n3．驱赶家禽、牲畜进入有顶蓬的场所，妥善保护易受冰雹袭击的农作物以及汽车等室外物品或者设备；\n4．注意防御冰雹天气伴随的雷电灾害。";
      break;
    case "冰雹红色":
      return "1．政府及相关部门按照职责做好防冰雹的应急和抢险工作；\n2．户外行人立即到安全的地方暂避；\n3．驱赶家禽、牲畜进入有顶蓬的场所，妥善保护易受冰雹袭击的农作物以及汽车等室外物品或者设备；\n4．注意防御冰雹天气伴随的雷电灾害。";
      break;
    case "大雾黄色":
      return "1．有关部门和单位按照职责做好防雾准备工作；\n2．机场、高速公路、轮渡码头等单位加强交通管理，保障安全；\n3．驾驶人员注意雾的变化，小心驾驶。";
      break;
    case "大雾橙色":
      return "1．有关部门和单位按照职责做好防雾工作；\n2．机场、高速公路、轮渡码头等单位加强调度指挥；\n3．驾驶人员必须严格控制车、船的行进速度。";
      break;
    case "大雾红色":
      return "1．有关部门和单位按照职责做好防雾应急工作；\n2．有关单位按照行业规定适时采取交通安全管制措施，如机场暂停飞机起降，高速公路暂时封闭，轮渡暂时停航等；\n3．驾驶人员根据雾天行驶规定，采取雾天预防措施，根据环境条件采取合理行驶方式，并尽快寻找安全停放区域停靠。";
      break;

    case "霾黄色":
      return "1．空气质量明显降低，人员需适当防护；\n2．一般人群适量减少户外活动，儿童、老人及易感人群应减少外出。";
      break;
    case "霾橙色":
      return "1．空气质量差，人员需适当防护；\n2.一般人群减少户外活动，儿童、老人及易感人群应尽量避免外出。";
      break;
    case "霾红色":
      return "1．政府及相关部门按照职责采取相应措施，控制污染物排放；\n2．空气质量很差，人员需加强防护；\n3．一般人群避免户外活动，儿童、老人及易感人群应当留在室内；\n4．机场、高速公路、轮渡码头等单位加强交通管理，保障安全；\n5．驾驶人员谨慎驾驶。";
      break;

    case "道路结冰黄色":
      return "1．交通、公安等部门要按照职责做好道路结冰应对准备工作；\n2．驾驶人员应当注意路况，安全行驶；\n3．行人外出注意防滑。";
      break;
    case "道路结冰橙色":
      return "1．交通、公安等部门要按照职责做好道路结冰应急工作；\n2．驾驶人员必须采取防滑措施，听从指挥，慢速行使；\n3．行人外出采取防滑措施。";
      break;

    case "道路结冰红色":
      return "1．交通、公安等部门做好道路结冰应急和抢险工作；\n2．交通、公安等部门注意指挥和疏导行驶车辆，必要时关闭结冰道路交通；\n3．托儿所、幼儿园、中小学校、中等职业学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施；\n4. 除直接保障社会公众生产生活运行的单位外，其他单位可以采取临时停工、停业或者调整工作时间等措施；\n5. 遇有突发危及安全的情况，城市轨道交通等公共运输工具驾驶员、车站行车人员、地下空间管理人员应当及时向有关部门报告，并可以先行采取停运停工、疏散人员等紧急安全防护措施；\n6．人员尽量减少外出。";
      break;

    default:
      return "无";
  }
};

const getWarnImgAndColor = (level: string) => {
  let background = "";
  let imgUrl = "";
  let color = "";
  if (level.indexOf("红色")) {
    color = "#fff";
    background = "#FF2626";
    imgUrl = "/static/image/mapbtn_gis/map_warn_red.png";
  } else if (level.indexOf("橙色")) {
    color = "#333";
    background = "#F78C21";
    imgUrl = "/static/image/mapbtn_gis/map_warn_orange.png";
  } else if (level.indexOf("黄色")) {
    color = "#333";
    background = "#FAED26";
    imgUrl = "/static/image/mapbtn_gis/map_warn_yellow.png";
  } else if (level.indexOf("蓝色")) {
    color = "#fff";
    background = "#0048FF";
    imgUrl = "/static/image/mapbtn_gis/map_warn_blue.png";
  }
  return { background, imgUrl, color };
};

const getWarnCategoryImg = (level: string) => {
  switch (level) {
    case "红色":
      return "/static/warningIcon/linzai_red.png";
    case "橙色":
      return "/static/warningIcon/linzai_orange.png";
    default:
      return "/static/warningIcon/linzai_orange.png";
  }
};
const getWarnCategoryFyzn = (level: string) => {
  console.log(level);
  switch (level) {
    case "乡镇红色":
      return "1．政府及有关部门启动应急预案，做好防御暴雨应急和抢险工作；\n2．托儿所、幼儿园、中小学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施；\n3. 露天施工、井下作业等高风险行业应停工，停止危险地带户外活动，尽量减少外出，旅游景点暂停营业；\n4.做好山洪、滑坡、崩塌、泥石流等灾害的防御和抢险工作，转移危险地带人员至安全场所。";
    case "乡镇橙色":
      return "1．政府及有关部门适时启动应急预案，做好防御暴雨的应急准备工作；\n2．托儿所、幼儿园、中小学校等应停止户外教学活动，采取措施保护到校学生、幼儿和其他上班人员的安全；\n3．露天施工、井下作业等行业可以停工，暂停户外作业；\n4．转移地质灾害危险地带人员和危房居民到安全场所避雨；\n5．做好农田排涝，防范暴雨可能引发的山洪、崩塌、滑坡、泥石流等灾害。";
    case "城市红色":
      return "1．政府及有关部门启动应急预案，做好防御暴雨应急和抢险工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施，未启程上学的学生不必到校上课，上学途中的学生可以就近到安全场所暂避；\n3. 除直接保障社会公众生产生活运行的单位外，露天施工、井下作业等高风险行业应停工，停止户外大型活动和群众集会，旅游景区景点暂停营业，其他单位可以采取临时停工、停业或者调整工作时间等措施；\n4. 遇有突发危及安全的情况，城市轨道交通等公共运输工具驾驶员、车站行车人员、地下空间管理人员应当及时向有关部门报告，并可以先行采取停运停工、疏散人员等紧急安全防护措施；\n5．在立交桥、低洼路段等易涝点设置警示标识，根据实际情况增加排水设施，做好城市内涝、崩塌等灾害的防御和抢险工作；\n6．在安全隐患路段实行道路警戒和交通管制，保障安全，驾驶人员注意路滑和塌方，快速撤离，确保行车安全。";
    case "城市橙色":
      return "1．政府及有关部门适时启动应急预案，做好防御暴雨的应急准备工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应停止户外教学活动，采取措施保护到校学生、幼儿和其他上班人员的安全；\n3．露天施工、井下作业等行业可以停工，暂停户外作业；\n4．转移地质灾害危险地带人员和危房居民到安全场所避雨；\n5．排水设施运营单位做好排水管网和防涝设施的运行检查和维护，保持排水通畅，防范暴雨可能引发的城市内涝、崩塌等灾害。";
    default:
      return "无";
  }
};

const getWarnCategoryImgByContent = (content: string) => {
  let level = "橙色";
  if (content.indexOf("红色") > -1) {
    level = "红色";
  } else if (content.indexOf("橙色") > -1) {
    level = "橙色";
  }
  switch (level) {
    case "红色":
      return "/static/warningIcon/linzai_red.png";
    case "橙色":
      return "/static/warningIcon/linzai_orange.png";
    default:
      return "/static/warningIcon/linzai_orange.png";
  }
};

const getWarnCategoryFyznByContent = (content: string) => {
  let level = "";
  let type = "";
  if (content.indexOf("红色") > -1) {
    level = "红色";
  } else if (content.indexOf("橙色") > -1) {
    level = "橙色";
  }
  if (content.indexOf("城市") > -1) {
    type = "城市";
  } else if (content.indexOf("乡镇") > -1) {
    type = "乡镇";
  }

  const keyword = type + level;
  console.log(keyword);
  switch (keyword) {
    case "乡镇红色":
      return "1．政府及有关部门启动应急预案，做好防御暴雨应急和抢险工作；\n2．托儿所、幼儿园、中小学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施；\n3. 露天施工、井下作业等高风险行业应停工，停止危险地带户外活动，尽量减少外出，旅游景点暂停营业；\n4.做好山洪、滑坡、崩塌、泥石流等灾害的防御和抢险工作，转移危险地带人员至安全场所。";
    case "乡镇橙色":
      return "1．政府及有关部门适时启动应急预案，做好防御暴雨的应急准备工作；\n2．托儿所、幼儿园、中小学校等应停止户外教学活动，采取措施保护到校学生、幼儿和其他上班人员的安全；\n3．露天施工、井下作业等行业可以停工，暂停户外作业；\n4．转移地质灾害危险地带人员和危房居民到安全场所避雨；\n5．做好农田排涝，防范暴雨可能引发的山洪、崩塌、滑坡、泥石流等灾害。";
    case "城市红色":
      return "1．政府及有关部门启动应急预案，做好防御暴雨应急和抢险工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应当根据县级以上人民政府教育等有关部门的决定，采取停课等措施，未启程上学的学生不必到校上课，上学途中的学生可以就近到安全场所暂避；\n3. 除直接保障社会公众生产生活运行的单位外，露天施工、井下作业等高风险行业应停工，停止户外大型活动和群众集会，旅游景区景点暂停营业，其他单位可以采取临时停工、停业或者调整工作时间等措施；\n4. 遇有突发危及安全的情况，城市轨道交通等公共运输工具驾驶员、车站行车人员、地下空间管理人员应当及时向有关部门报告，并可以先行采取停运停工、疏散人员等紧急安全防护措施；\n5．在立交桥、低洼路段等易涝点设置警示标识，根据实际情况增加排水设施，做好城市内涝、崩塌等灾害的防御和抢险工作；\n6．在安全隐患路段实行道路警戒和交通管制，保障安全，驾驶人员注意路滑和塌方，快速撤离，确保行车安全。";
    case "城市橙色":
      return "1．政府及有关部门适时启动应急预案，做好防御暴雨的应急准备工作；\n2．托儿所、幼儿园、中小学校、中等职业学校等应停止户外教学活动，采取措施保护到校学生、幼儿和其他上班人员的安全；\n3．露天施工、井下作业等行业可以停工，暂停户外作业；\n4．转移地质灾害危险地带人员和危房居民到安全场所避雨；\n5．排水设施运营单位做好排水管网和防涝设施的运行检查和维护，保持排水通畅，防范暴雨可能引发的城市内涝、崩塌等灾害。";
    default:
      return "无";
  }
};

export default {
  getImgSrc,
  getWarnImgAndColor,
  getFyzn,
  getWarnCategoryImg,
  getWarnCategoryFyzn,
  getWarnCategoryImgByContent,
  getWarnCategoryFyznByContent,
};
